// extracted by mini-css-extract-plugin
export var banner = "_p3-0";
export var settingRow = "_p3-2";
export var titleIcon = "_p3-1";